// DELEGATE — the chats query and its invalidator live in `@heidi/session/data`
// (ARCFE-1003).
//
// A PURE RE-EXPORT again. This file carried a surface gate while
// `GET /v2/chat/sessions/:id/chats` belonged to ml-scribe's cloud-only chat
// router; chat history now moves to the shared router that `main_onprem` mounts
// too, so the route exists on every profile and there is no app fact left here
// to resolve (see the served list in `src/utils/backendSurfaces.ts`). The three
// mount points — ResizableMenuPanels, the Evidence sidebar panel and its drawer
// — still call `useAutoSelectRecentSessionChat` unconditionally, and that is
// fine now: an appliance answers with the session's chats.
//
// The package hook keeps its `enabled` parameter (default open), so a future
// gate has a seam to arrive through.
//
// LOAD-BEARING side-effect import — the legacy module's own value import of
// the scribe clients, kept so evaluation order is unchanged for suites that
// import this shim (the ARCFE-990 rule). Deleted with this shim at Z2.
import '@/utils/scribeHTTP';

export {
  GET_SESSION_CHATS,
  invalidateSessionChats,
  useQuerySessionChats,
} from '@heidi/session/data';
